import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {culturesActionTypes, LoadCulturesSuccessAction, UpdateCulturesSuccessAction} from '../actions/cultures';
import {Culture} from '../models/culture';
import {SEPARATOR_SELECT} from '..';

export interface CulturesState {
  array: Culture[];
}

const initialState: CulturesState = {
  array: []
};

export function culturesReducer(state: CulturesState = initialState, action: Action): CulturesState {
  switch (action.type) {
    case culturesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case culturesActionTypes.UPDATE:
      return handleUpdateAction(state, action);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: CulturesState, action: LoadCulturesSuccessAction): CulturesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  const newState2 = _.cloneDeep(newState);
  for (let i = 0; i < newState.array.length   ; i++) {

    newState2.array[i].englishName =   newState.array[i].name +  '   -   ' + newState.array[i].englishName   ;
  }
  return newState2;
}
function handleUpdateAction(state: CulturesState, action: UpdateCulturesSuccessAction): CulturesState {
  const newState = _.clone(state);
  const separator = {'name': SEPARATOR_SELECT, 'englishName': SEPARATOR_SELECT, 'code': '' , 'common': false , 'rtl': false}
  const indexCulture =  _.findIndex( newState.array, function (o: Culture): boolean { return o.name === SEPARATOR_SELECT; });
  const arraySmall = [];
  const newState2 = _.cloneDeep(action.payload);
  for (let i = 0; i < indexCulture; i++) {
    arraySmall.push(newState.array[i])
  }
  for (let i = 0; i < newState2.length   ; i++) {
    newState2[i].englishName =   newState2[i].name  +  '   -   ' + newState2[i].englishName   ;
  }
  newState.array = _.concat(newState.array , arraySmall);
  newState.array = _.drop(newState.array, (indexCulture + 1));
  newState.array = _.concat(newState2, separator , newState.array);
  newState.array = _.uniqBy(newState.array, 'code');
  return newState;
}

export const culturesSelectors = {
  array: (state: CulturesState) => _.get(state, 'array', []),
  cultureByCode: (state: CulturesState, props: string) => {
    return state.array.filter((culture: Culture) => culture.code === props);
  }
};
